import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "SurfaceActionsOption" */ "./lazyIndex"), { name: "SurfaceActionsOption" });

export const lazyInitializeHoverSurfaceAction: LazyAction<typeof lazyIndex.initializeHoverSurfaceAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeHoverSurfaceAction);
export const lazySaveHoverSurfaceActionService: LazyAction<typeof lazyIndex.saveHoverSurfaceActionService, typeof lazyModule> = new LazyAction(lazyModule, m => m.saveHoverSurfaceActionService);

export const lazyFetchShowSettingsHoverAction: LazyAction<typeof lazyIndex.fetchShowSettingsHoverAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchShowSettingsHoverAction);

export const lazySaveShowSettingsHoverAction: LazyAction<typeof lazyIndex.saveShowSettingsHoverAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.saveShowSettingsHoverAction);

export { default as getStore } from "./store/store";
export { default as getHoverSurfaceAction, getHoverActionKeysFromMailTriageActions, } from "./utils/hoverSurfaceActionHelper";

export { default as SurfaceActionsOptionState } from "./store/schema/SurfaceActionsOptionState";
